import { h, Fragment } from 'preact'
import { signal } from '@preact/signals'
import { useLayoutEffect } from 'preact/hooks'
import { insertNodeAround, isEmptyObject, isDesktop, isMobile, capitalizeFirstLetter, replaceFilter, replaceCleaner } from '../../js/modules/utilities.js'
import { attachClampByQuery } from '../../js/modules/clamp.js'
import { setAllToMaxHeight } from '../../js/modules/setAllToMaxHeight.js'
import Glide from '@glidejs/glide'
import { JoCountdown } from '../jo-countdown/jo-countdown.jsx'

export const newsState = signal('')

var newsEventsMenu = {}
var sliders = {}

var filInfo = {}
var pasDePorte = {}
var autopromo = {}
var joCountDown = {}

export const News = (props) => {
   if (isEmptyObject(sliders)) {
      if (isMobile()) {
         // il n'y a pas de slider focus en mobile
         sliders = {
            'o-news-actu': {},
            'o-news-media1': {},
            'o-news-sport': {},
            'o-news-media2': {},
         }
      } else {
         sliders = {
            'o-news-actu': {},
            'o-news-focus': {},
            'o-news-sport': {},
            'o-news-media1': {},
            'o-news-media2': {},
            'o-news-media3': {},
         }
      }
   }

   if (newsState.value !== '' && newsState.value['newsEventsMenu'] !== undefined) newsEventsMenu = newsState.value['newsEventsMenu']
   if (newsState.value !== '' && newsState.value['o-news-actu'] !== undefined) sliders['o-news-actu'] = newsState.value['o-news-actu']
   if (!isMobile() && newsState.value !== '' && newsState.value['o-news-focus'] !== undefined) sliders['o-news-focus'] = newsState.value['o-news-focus']
   if (newsState.value !== '' && newsState.value['o-news-sport'] !== undefined) sliders['o-news-sport'] = newsState.value['o-news-sport']
   if (newsState.value !== '' && newsState.value['o-news-media1'] !== undefined) sliders['o-news-media1'] = newsState.value['o-news-media1']
   if (newsState.value !== '' && newsState.value['o-news-media2'] !== undefined) sliders['o-news-media2'] = newsState.value['o-news-media2']
   if (!isMobile() && newsState.value !== '' && newsState.value['o-news-media3'] !== undefined) sliders['o-news-media3'] = newsState.value['o-news-media3']
   if (newsState.value !== '' && newsState.value['newsFilInfo'] !== undefined) filInfo = newsState.value['newsFilInfo']
   if (newsState.value !== '' && newsState.value['pasDePorte'] !== undefined) pasDePorte = newsState.value['pasDePorte']
   if (newsState.value !== '' && newsState.value['newsAutopromo'] !== undefined) autopromo = newsState.value['newsAutopromo']
   if (newsState.value !== '' && newsState.value['joCountDown'] !== undefined) joCountDown = newsState.value['joCountDown']

   return isMobile() ? <NewsMobile {...props} /> : <NewsDesktop {...props} />
}

const isSliderDataFull = () => {
   let result = true
   for (const [key, value] of Object.entries(sliders)) {
      if (isEmptyObject(value)) result = false
   }
   return result
}

const sliderFormater = () => {
   let result = []
   for (const [key, value] of Object.entries(sliders)) {
      value.name = key
      result.push(value)
   }
   return result
}

const NewsDesktop = ({ title, meteo, menu, allNewsCTA, publicite }) => {
   return (
      <div class="container-fluid">
         <div class={`row mb-3 o-news mt-1`} id="oNews" data-testid="bande-news">
            <div class="col-6 col-lg-8 js-onews-left">
               <div class="row">
                  {!isEmptyObject(joCountDown) ? <JoCountdown {...joCountDown} /> : null}

                  <div class="col-12 d-flex align-items-baseline onews-menu" data-testid="news-menu">
                     <Titre {...title} />

                     {!isEmptyObject(newsEventsMenu) ? <Menu {...menu} events={newsEventsMenu.menu.events} cacheKey={newsEventsMenu.cacheKey} /> : ''}
                  </div>

                  <h2 class="sr-only">Les news du moment</h2>

                  {isSliderDataFull() ? sliderFormater().map((item) => <SliderDesktop {...item} adsId={publicite.nativeAdsId} />) : null}

                  <AllNewsButton {...allNewsCTA} />
               </div>
            </div>

            <div id="totemColumn" class="col-6 col-lg-4 totemColumn position-relative">
               <div class="totemContent">
                  <div>
                     {!isEmptyObject(publicite) ? <PubliciteDesktop {...publicite} /> : null}
                     <Meteo {...meteo} />
                  </div>

                  <div class="containerFilInfo">{!isEmptyObject(filInfo) ? <FilInfo {...filInfo} /> : ''}</div>

                  {!isEmptyObject(pasDePorte) ? <PasDePorte {...pasDePorte} /> : null}
               </div>
            </div>
         </div>
      </div>
   )
}

const NewsMobile = ({ meteo, publicite, allNewsCTA }) => {
   return (
      <div class="container-fluid">
         <div class="row o-news" id="oNews" data-testid="bande-news">
            <div class="col-12">
               <h2 class="mb-1">News</h2>
            </div>

            {isSliderDataFull() ? sliderFormater().map((item) => <SliderMobile {...item} />) : null}

            {!isEmptyObject(publicite) ? <PubliciteMobile {...publicite} /> : null}
         </div>

         <div class="row">
            <div class="col-12">
               <h3 class="mb-0">Infos en direct</h3>
               {!isEmptyObject(filInfo) ? <FilInfo {...filInfo} /> : ''}
            </div>

            <div class="col-12">
               <div class="d-flex justify-content-between justify-content-sm-around sm-smallBlocks">
                  <Meteo {...meteo} />
               </div>
            </div>

            <AllNewsButton {...allNewsCTA} />
         </div>
      </div>
   )
}

const Titre = ({ URL, analytics, label }) => {
   return (
      <div class={`h2 no-signature mr-2 mb-1`}>
         <a
            href={URL}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            {label}
         </a>
      </div>
   )
}

const Menu = ({ text, events, cacheKey }) => {
   return (
      <nav class="w-100" role="navigation" aria-label="News">
         <ul class="block-title overflow-hidden mb-0 block-title__fixed" id="oNews_menu">
            {text.map((data, index) => (
               <li class="block-title-item d-none d-lg-inline-block" data-testid={`news-menu-text${index}`}>
                  <a
                     href={data.URL}
                     class="title"
                     data-oevent-category={data.analytics.oeventCategory}
                     data-oevent-action={data.analytics.oeventAction}
                     data-oevent-label={data.analytics.oeventLabel}
                     data-oevent-other={data.analytics.oeventOther}
                  >
                     {data.label}
                  </a>
               </li>
            ))}
            {events.map((data) => (
               <li class="block-title-item d-inline-block" data-testid="news-menu-icon" data-cache-key={cacheKey}>
                  <a
                     href={data.URL}
                     class="title"
                     title={data.title}
                     target={data.target}
                     data-oevent-category={data.analytics.oeventCategory}
                     data-oevent-action={data.analytics.oeventAction}
                     data-oevent-label={data.analytics.oeventLabel}
                     data-oevent-other={data.analytics.oeventOther}
                     data-pdb-zid={data.analytics.pdbZid}
                     data-pdb-sc={data.analytics.pdbSc}
                     data-pdb-idc={data.analytics.pdbIdc}
                     data-pdb-vi={data.analytics.pdbVi}
                  >
                     {data.image == '' ? data.title : <img loading="lazy" src={data.image} alt={data.alt} />}
                  </a>
               </li>
            ))}
         </ul>
      </nav>
   )
}

const AllNewsButton = ({ URL, label, analytics }) => {
   return isMobile() ? (
      <div class="col-12 mb-2 mt-2 d-flex justify-content-center">
         <a
            href={URL}
            class="btn btn-secondary"
            data-testid="news-voir-toutes"
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            {label}
         </a>
      </div>
   ) : (
      <div class="col-12 d-flex justify-content-center js-onews-left-cta">
         <a
            href={URL}
            class="btn btn-secondary mt-1 mt-xl-2"
            data-testid="news-voir-toutes"
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            {label}
         </a>
      </div>
   )
}

const PubliciteDesktop = ({ nativeAdsId, rmAdsId }) => {
   useLayoutEffect(() => {}, [])

   return (
      <Fragment>
         {/* Pub Autopromo advise */}
         {!isEmptyObject(autopromo) ? <OccasionnelONews {...autopromo} /> : null}

         {/* Pub RM adgateway */}
         {rmAdsId !== '' ? <div id={rmAdsId} class="tag-rm"></div> : null}
      </Fragment>
   )
}

const OccasionnelONews = ({ URL, alt, image, analytics }) => {
   return (
      <div id="zone_news_foisonnement-b" class="foisonnement-onews" data-testid="zone-foisonnement-b">
         <a
            href={URL}
            class="d-block"
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-pdb-ta={analytics.pdbTa}
            data-adv-canal={analytics.advCanal}
            data-adv-cappingdata={analytics.advCappingdata}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            <picture>
               <source srcset={`${image}?format=480x310&saveas=webp`} media="(max-width: 1199px)" />
               <img src={`${image}?crop=480,310,0,39&saveas=webp`} alt={alt} loading="lazy" />
            </picture>
         </a>
      </div>
   )
}

const PubliciteMobile = ({ nativeAdsId }) => {
   return (
      <div class="col-12 col-sm-6 mb-1">
         <div class="tuile o-media-mobile d-none native-news-container">
            <a href="#" title="" class="onews-reference native-news-link w-100">
               <div class="main-wrapper">
                  <div class="wrapper">
                     <div>
                        <img loading="lazy" alt="" class="image native-news-picture" />
                     </div>
                  </div>
                  <div class="wrapper text-secondary js-news-thumb native-news-wrapper-content position-relative">
                     <h3 class="category standard text-gray3 d-block py-0 my-0 text-truncate native-news-category"></h3>
                     <strong data-clamp-line="3" class="title lead font-weight-bold m-0 native-news-title"></strong>
                  </div>
               </div>
            </a>
         </div>
         <div id={nativeAdsId}></div>
      </div>
   )
}

const Meteo = ({ URL, analytics, text }) => {
   return (
      <a
         class="meteo-ville"
         data-testid="news-meteo"
         href={URL}
         data-oevent-category={analytics.oeventCategory}
         data-oevent-action={analytics.oeventAction}
         data-oevent-label={analytics.oeventLabel}
         data-oevent-other={analytics.oeventOther}
      >
         <svg class="svg-meteo" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 1000 1000">
            <path d="M867.522,571.935a258.246,258.246,0,0,0,5.775-54.374c0-142.4-115.667-257.831-258.351-257.831A258.038,258.038,0,0,0,413.8,355.776,105.8,105.8,0,0,0,286.64,448.642c-92.928,11.311-164.91,90.319-164.91,186.115,0,103.561,84.122,187.513,187.892,187.513H779.351c77.828,0,140.919-62.964,140.919-140.635A140.259,140.259,0,0,0,867.522,571.935ZM670.6,640.56V392.145a44.1,44.1,0,1,0-88.194,0v14.717h22.049a7.359,7.359,0,0,1,0,14.717H582.4V436.3h22.049a7.359,7.359,0,0,1,0,14.717H582.4v14.717h22.049a7.358,7.358,0,0,1,0,14.716H582.4V640.56A73.5,73.5,0,1,0,670.6,640.56ZM626.5,743.58a44.162,44.162,0,0,1-22.342-82.218v-145.6a22.343,22.343,0,1,1,44.685,0v145.6A44.163,44.163,0,0,1,626.5,743.58ZM174.118,464.929c-0.075-2.183-.127-4.372-0.127-6.573,0-103.5,83.939-187.406,187.484-187.406a186.8,186.8,0,0,1,79.972,17.869A279.118,279.118,0,0,1,513,248.83l-8.622-39.406-84.051,26.754L360.919,171l-59.408,65.178-84.052-26.754-18.846,86.138L112.44,314.4l26.765,84.017L74,457.8,131.317,510A212.524,212.524,0,0,1,174.118,464.929Z" />
         </svg>
         <span class="o-link-arrow">{text}</span>
      </a>
   )
}

const FilInfo = ({ news, title }) => {
   const duration = (4 + 0.3) * news.length
   const styleAnimation = {
      animationName: 'ticker',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
      animationFillMode: 'none',
      animationDuration: `${duration}s`,
   }

   useLayoutEffect(() => {
      if (!isMobile() && !isEmptyObject(filInfo)) newsFeedInit()

      attachClampByQuery('#newsFilInfo [data-clamp-line]')
      document.querySelectorAll('#newsFilInfo [data-clamp-line]').forEach((elmt) => {
         elmt.addEventListener('end.clamp', () => {
            insertNodeAround(elmt, ' - ', "<span class='title-cat mb-0'><strong>", '</strong></span>')
         })
      })
   }, [])

   return (
      <Fragment>
         {isDesktop() ? <h3 class="sr-only">{title}</h3> : ''}
         <div id="newsFeedContainer" class="newsfeed" data-testid="fil-info">
            <ul
               style={isDesktop() ? styleAnimation : ''}
               class={`${isDesktop() ? 'bg-gray2 px-2 newsFilInfoAnimate' : 'mobile bg-white'} list-group list-group-flush listeActu js-resizable`}
               id="newsFilInfo"
            >
               <FilInfoList news={news} />
               {!isMobile() ? <FilInfoList news={news} shadow={true} /> : ''}
            </ul>
         </div>
      </Fragment>
   )
}

const FilInfoList = ({ news, shadow }) => {
   return (
      <Fragment>
         {news.map((info, index) => (
            <li id={`${!shadow ? `newsticker${index + 1}` : ''}`} class={`${isDesktop() ? 'bg-gray2' : 'bg-white'} list-group-item flex-column align-items-center py-1 px-0`}>
               <a
                  href={info.URL}
                  title={info.title}
                  class="standard px-0 news-fil-info-link"
                  tabindex={shadow ? '-1' : null}
                  aria-hidden={shadow ? 'true' : null}
                  data-oevent-category={info.analytics.oeventCategory}
                  data-oevent-action={info.analytics.oeventAction}
                  data-oevent-label={info.analytics.oeventLabel}
                  data-oevent-other={info.analytics.oeventOther}
               >
                  <div class="news-fil-info-wrap d-flex w-100">
                     <span class={`${isDesktop() ? 'pr-2' : 'pr-1'} align-self-center news-fil-info-date`}>{info.time}</span>
                     <span class="news-fil-info-title" data-clamp-line={`${isDesktop() ? '2' : '1'}`}>
                        <span class="title-cat mb-0">
                           <strong>{capitalizeFirstLetter(info.category)}</strong>
                        </span>{' '}
                        - <span class="desc">{info.title}</span>
                     </span>
                  </div>
               </a>
            </li>
         ))}
      </Fragment>
   )
}

const PasDePorte = ({ pasDePorte, cacheKey }) => {
   const ad = pasDePorte.ads[0] //temporaire le temps que le back ne remonte qu'un element
   return (
      <div class="mt-2 js-fixed" data-cache-key={cacheKey}>
         <a
            href={ad.URL}
            title={`${replaceCleaner(ad.title)}`}
            class="pasDePorte"
            data-testid={`pas-de-porte`}
            target={ad.target ? '_blank' : ''}
            data-oevent-category={ad.analytics.oeventCategory}
            data-oevent-action={ad.analytics.oeventAction}
            data-oevent-label={ad.analytics.oeventLabel}
            data-oevent-other={ad.analytics.oeventOther}
            data-pdb-zid={ad.analytics.pdbZid}
            data-pdb-sc={ad.analytics.pdbSc}
            data-pdb-idc={ad.analytics.pdbIdc}
            data-pdb-vi={ad.analytics.pdbVi}
         >
            <img src={`${ad.image}?quality=85&format=100x100`} alt="" height="50" width="50" loading="lazy" />
            <h3 class="pasDePorte_title" dangerouslySetInnerHTML={{ __html: replaceFilter(ad.title) }}></h3>
         </a>
      </div>
   )
}

const SliderDesktop = ({ items, name, title, cacheKey, adsId }) => {
   useLayoutEffect(() => {
      if (isSliderDataFull()) mediaGlideInit()
   }, [])

   const getAdsId = (name, index, adsId) => {
      let returnedAdsId = null
      if (name === 'o-news-focus') {
         if (index === 1) returnedAdsId = { id: adsId[0], 'widget-id': 'SF_2' }
         if (index === 3) returnedAdsId = { id: adsId[1] }
      }
      return returnedAdsId
   }

   return (
      <div class="col-12 col-lg-6" data-cache-key={cacheKey}>
         {title !== '' ? <h3 class="sr-only">{title}</h3> : ''}
         <div class={`tuile mb-2 o-media glide glide-slider ${name} ${name === 'o-news-focus' ? 'native-news-container' : ''}`} data-testid={`news-slider-${name}`}>
            <div class="glide__track" data-glide-el="track">
               <ul class="glide__slides">
                  {items.map((item, index) => (
                     <VignetteDesktop {...item} index={index + 1} nbItems={items.length} name={name} adsId={getAdsId(name, index, adsId)} />
                  ))}
               </ul>
            </div>
         </div>
      </div>
   )
}

const VignetteDesktop = ({ category, URL, title, target, image, analytics, index, nbItems, navigation, name, adsId }) => {
   // Permet d'ajuster la hauteur des vignettes entre les carrousels adjacent horizontalement
   let newsline = '0'
   if (name === 'o-news-actu' || name === 'o-news-focus') newsline = '1'
   else if (name === 'o-news-sport' || name === 'o-news-media1') newsline = '2'

   return (
      <li class="glide__slide slick-slide" {...adsId}>
         <div
            class="onews-reference lien-composite"
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            <div class="pt-1">
               <div class="wrapper bg-gray2 pb-1 mr-1">
                  <picture class="ml-1 mt--1 mr--1 wrapper-image w-100">
                     <source srcset={`${image}?saveas=webp&format=435x`} media="(max-width: 959px)" />
                     <source srcset={`${image}?saveas=webp&format=345x`} media="(max-width: 1199px)" />
                     <img loading="lazy" src={`${image}?saveas=webp&format=420x`} alt="" aria-hidden="true" class=" image w-100" />
                  </picture>
               </div>
               <div class={`wrapper bg-gray2 px-1 pb-1 mr-1 text-secondary js-news-line${newsline}`} data-sameheight-active="(min-width: 960px)">
                  <span class="category standard font-weight-bold text-gray3 d-block py-0 my-0">
                     {category}
                  </span>
                  <a href={URL} target={target}>
                     <h4 data-clamp-line="3" class="title lead font-weight-bold m-0 pb-0">
                        {title}
                     </h4>
                  </a>
                  <div class="pagination-news" data-glide-el="controls" aria-hidden="true">
                     <span
                        class="prev-news icon-arrow-previous"
                        title={navigation.previous.title}
                        data-glide-dir="<"
                        data-oevent-category={navigation.previous.analytics.oeventCategory}
                        data-oevent-action={navigation.previous.analytics.oeventAction}
                        data-oevent-label={navigation.previous.analytics.oeventLabel}
                        data-oevent-other={navigation.previous.analytics.oeventOther}
                     ></span>
                     <div class="paging">
                        <strong>{index}</strong> / {nbItems}
                     </div>
                     <span
                        class="next-news icon-arrow-next"
                        title={navigation.previous.title}
                        data-glide-dir=">"
                        data-oevent-category={navigation.next.analytics.oeventCategory}
                        data-oevent-action={navigation.next.analytics.oeventAction}
                        data-oevent-label={navigation.next.analytics.oeventLabel}
                        data-oevent-other={navigation.next.analytics.oeventOther}
                     ></span>
                  </div>
               </div>
            </div>
         </div>
      </li>
   )
}

const SliderMobile = ({ items, title, name, cacheKey }) => {
   useLayoutEffect(() => {
      if (isSliderDataFull()) mediaMobileGlideInit()
   }, [])

   return (
      <div class="col-12 col-sm-6 mb-1" data-cache-key={cacheKey}>
         {title !== '' ? <h3 class="sr-only">{title}</h3> : ''}
         <div class={`tuile o-media-mobile glide glide-slider ${name}`} data-testid={`news-slider-${name}`}>
            <div class="glide__track" data-glide-el="track">
               <ul class="glide__slides">
                  {items.map((item, index) => (
                     <VignetteMobile {...item} index={index + 1} nbItems={items.length} />
                  ))}
               </ul>
            </div>
         </div>
      </div>
   )
}

const VignetteMobile = ({ category, URL, title, target, image, analytics }) => {
   return (
      <li class="glide__slide">
         <div
            class="onews-reference lien-composite"
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            <div class="main-wrapper">
               <div class="wrapper">
                  <picture>
                     <source srcset={`${image}?saveas=webp&format=435x`} media="(max-width: 959px)" />
                     <source srcset={`${image}?saveas=webp&format=345x`} media="(max-width: 1199px)" />
                     <img loading="lazy" src={`${image}?saveas=webp&format=420x`} alt="" aria-hidden="true" class="image" />
                  </picture>
               </div>

               <div class="wrapper text-secondary js-news-thumb" data-sameheight-active="(min-width: 480px)">
                  <span class="category standard font-weight-bold text-gray3 d-block py-0 my-0 text-truncate">{category}</span>
                  <a href={URL} target={target}>
                     <h4 data-clamp-line="3" class="title lead font-weight-bold m-0 pb-0">
                        {title}
                     </h4>
                  </a>
               </div>
            </div>
         </div>
      </li>
   )
}

/**
 * NEWS FEED
 */
let keyframes = null
let CSSruleIndex = null
let numberOfNews = 0

const newsFeedGenerateKeyframe = function (numberOfNews) {
   const newsHeight = document.querySelector('#newsticker1').offsetHeight
   const animationTime = 0.3
   const animationPause = 4
   const totalTime = (animationTime + animationPause) * numberOfNews
   const animationStepTime = (animationTime / totalTime) * 100
   const pauseStepTime = (animationPause / totalTime) * 100

   let keyframe = '@keyframes ticker {\n'

   let stepAnimation = 0
   let stepPause = 0
   let tickerXPosition = 0

   for (let step = 1; step <= numberOfNews + 1; step++) {
      stepPause = stepAnimation + pauseStepTime

      if (step === numberOfNews + 1) {
         keyframe += stepAnimation.toFixed(2) + '% { transform: translate3d(0px, ' + tickerXPosition + 'px, 0px);}\n'
         keyframe += stepPause.toFixed(2) + '% { transform: translate3d(0px, ' + tickerXPosition + 'px, 0px);}\n'
         keyframe += '100% { transform: translate3d(0px, ' + tickerXPosition + 'px, 0px); animation-timing-function: step-end;}\n'
      } else if (step === 1) {
         keyframe += stepAnimation.toFixed(2) + '% { transform: translate3d(0px, ' + tickerXPosition + 'px, 0px);animation-timing-function: step-start;}\n'
         keyframe += stepPause.toFixed(2) + '% { transform: translate3d(0px, ' + tickerXPosition + 'px, 0px);}\n'
      } else {
         keyframe += stepAnimation.toFixed(2) + '%, ' + stepPause.toFixed(2) + '% { transform: translate3d(0px, ' + tickerXPosition + 'px, 0px);}\n'
      }

      stepAnimation = stepPause + animationStepTime
      tickerXPosition = tickerXPosition - newsHeight
   }
   keyframe += '}'
   return keyframe
}

const newsFeedInsertCSSKeyframes = function (keyframe) {
   if (!keyframes) {
      keyframes = document.createElement('style')
      keyframes.type = 'text/css'
      document.head.appendChild(keyframes)
   }
   CSSruleIndex = keyframes.sheet.insertRule(keyframe, 0)
}

const newsFeedUpdate = function (numberOfNews) {
   let keyframe = newsFeedGenerateKeyframe(numberOfNews)
   keyframes.sheet.deleteRule(CSSruleIndex)
   CSSruleIndex = keyframes.sheet.insertRule(keyframe, 0)
   // Restart animation
   var element = document.getElementById('newsFilInfo')
   element.classList.remove('newsFilInfoAnimate')
   void element.offsetWidth // trigger a DOM reflow
   element.classList.add('newsFilInfoAnimate')
}

const newsFeedInit = () => {
   numberOfNews = filInfo.news.length
   let keyframe = newsFeedGenerateKeyframe(numberOfNews)
   newsFeedInsertCSSKeyframes(keyframe)
   onResize(document.querySelector('#newsticker1'), () => {
      // if fonts size change, generate a new keyframe and resize
      newsFeedUpdate(numberOfNews)
   })
   // resize after init
   if (!isMobile()) {
      newsFeedUpdate(numberOfNews)
   } else {
      // if mobile display 3 news
      resizeContainer(3)
   }

   removeDataClampForAccessibility()
}

// Change the number of slides showed in the news feed slider
const newsFeedResize = (updateNewsFeed) => {
   if (updateNewsFeed) {
      newsFeedUpdate(filInfo.news.length)
   }
}

const onResize = function (element, callback) {
   if (!onResize.watchedElementData) {
      onResize.watchedElementData = []

      var checkForChanges = function () {
         onResize.watchedElementData.forEach(function (data) {
            if (data.element.offsetHeight !== data.offsetHeight) {
               data.offsetHeight = data.element.offsetHeight
               data.callback()
            }
         })
      }

      window.addEventListener('resize', checkForChanges)
      // eslint-disable-next-line no-undef
      var observer = new MutationObserver(checkForChanges)
      observer.observe(document.body, {
         attributes: true,
      })
   }

   onResize.watchedElementData.push({
      element: element,
      offsetHeight: element.offsetHeight,
      callback: callback,
   })
}

// En cas de zoom text, on retire l'elipsis sur le fil info
const removeDataClampForAccessibility = () => {
   let newsItem = document.querySelectorAll('.news-fil-info-title')
   let newsItemWrap = document.querySelectorAll('.news-fil-info-wrap')
   if (newsItem[0] !== undefined && getComputedStyle(newsItem[0]).fontSize !== '16px' && getComputedStyle(newsItem[0]).fontSize !== '14px') {
      newsItem.forEach((item) => {
         item.removeAttribute('style')
         item.removeAttribute('data-clamp-line')
         item.style.overflow = 'visible'
         item.style.height = 'auto'
      })
      newsItemWrap.forEach((item) => {
         item.classList.remove('d-flex')
      })
   }
}

/**
 * CARROUSELS MEDIA DESKTOP
 */
const mediaGlideInit = () => {
   const sliders = []
   let glideOption = {
      gap: 0,
      animationDuration: 0,
      autoplay: 10000,
   }

   var sliderCounter = 0

   document.querySelectorAll('.glide-slider').forEach((slider) => {
      let glideSlider = new Glide(slider, glideOption)

      // Callback after mount
      glideSlider.on('mount.after', () => {
         sliderCounter++
         if (sliderCounter === 6) {
            // TODO: setTimeout pour regler un souci due au css critique prospect
            setTimeout(function () {
               attachClampByQuery('.o-media [data-clamp-line]')
               setAllToMaxHeight('.js-news-line0')
               setAllToMaxHeight('.js-news-line1')
               setAllToMaxHeight('.js-news-line2')
               newsFeedResize(true)
            }, 5000)
         }
      })

      glideSlider.mount()
      sliders.push(glideSlider)
      glideSlider.pause()

      // Déclenchement des sliders suivant l'ordre défini
      const mediaSliderOrder = ['o-news-actu', 'o-news-media1', 'o-news-focus', 'o-news-sport', 'o-news-media2', 'o-news-media3']
      mediaSliderOrder.forEach((sliderName, index) => {
         let startTime = (index + 1) * 2000
         setTimeout(() => {
            if (glideSlider.selector.classList.contains(sliderName)) {
               glideSlider.go('>')
               glideSlider.play()
            }
         }, startTime)

         // ajout evenements pour accessibilité
         if (glideSlider.selector.classList.contains(sliderName)) {
            document.querySelectorAll('.' + sliderName + ' .onews-reference').forEach((el) => {
               el.addEventListener('focusin', (e) => {
                  glideSlider.pause()
                  e.currentTarget.classList.add('focus-within')
                  let slideIndex = Array.prototype.slice.call(el.parentNode.parentNode.children).indexOf(el.parentNode)
                  glideSlider.go('=' + slideIndex).pause()
               })
               el.addEventListener('focusout', (e) => {
                  e.currentTarget.classList.remove('focus-within')
                  glideSlider.play()
               })
            })
         }
      })
   })
   window.mediaSliders = sliders
}

/**
 * CARROUSELS MEDIA MOBILE
 */
const mediaMobileGlideInit = () => {
   const slidersMobile = []
   let glideOption = {
      gap: 0,
      animationDuration: 200,
      autoplay: 10000,
   }

   document.querySelectorAll('.glide-slider').forEach((slider) => {
      let glideSlider = new Glide(slider, glideOption)

      // Callback after mount
      glideSlider.on('mount.after', () => {
         attachClampByQuery('.o-media-mobile [data-clamp-line]')
         setAllToMaxHeight('.o-media-mobile .js-news-thumb [data-clamp-line]')
      })

      glideSlider.mount()
      slidersMobile.push(glideSlider)
      glideSlider.pause()

      // Déclenchement des sliders suivant l'ordre défini
      const mediaSliderOrder = ['o-news-actu', 'o-news-media1', 'o-news-sport', 'o-news-media2']
      mediaSliderOrder.forEach((sliderName, index) => {
         let startTime = (index + 1) * 2000
         setTimeout(() => {
            if (glideSlider.selector.classList.contains(sliderName)) {
               glideSlider.go('>')
               glideSlider.play()
            }
         }, startTime)
      })
   })
   window.mediaSliders = slidersMobile
}
